import { Icon_Cog, Icon_Message, Icon_Person, Sidebar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import { useTeam } from "../../../../hooks/useTeams";
import { useTracker } from "../../../../hooks/useTracker";
import { NavGroup } from "../NavGroup/NavGroup";
import { NavItem } from "../NavItem/NavItem";

export const DashboardNavGroup = () => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { teamData } = useTeam(teamID);
  const isSyncEnabled = !teamData?.addons?.syncForbidden;
  const isPrivateCloud = teamData?.addons?.privateCloud;

  if (!teamID) return null;

  return (
    <NavGroup>
      <Sidebar.ScrollContainer>
        {isSyncEnabled && (
          <NavItem
            name="shared-with-me"
            icon={<Icon_Person />}
            track={tracker.trackGoToSharedWithMe}
          >
            Shared with me
          </NavItem>
        )}
        {isSyncEnabled && !isPrivateCloud && (
          <NavItem name="versions" icon={<Icon_Message />} track={tracker.trackGoToReviewLinks}>
            Published versions
          </NavItem>
        )}
      </Sidebar.ScrollContainer>
      <Sidebar.Space marginTop={"auto"} />
      <Sidebar.Item
        onClick={() => {
          navigation.goToTeamMembers({ teamID });
        }}
      >
        <Icon_Cog /> {"Settings"}
      </Sidebar.Item>
    </NavGroup>
  );
};
